import MobileThreats from "./MobileThreats";

export default MobileThreats;
